import BaseComponent from "@js/components/base_component.jsx";

import EuiSharedTrackingDomainsForm from "@js/components/eui/shared_tracking_domains/form.jsx";

class EuiSharedTrackingDomainsShow extends BaseComponent {

  render() {
    return (
      <EuiSharedTrackingDomainsForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiSharedTrackingDomainsShow;
